<template>
	<v-card class="mx-0 mt-2">
		<v-card-text class="d-flex justify-space-between mb-0">
			<div class="d-flex flex-column">
				<span class="mr-auto">{{ $t('pay.order_no') }}：{{ order.sn }}</span>
				<span class="mr-auto">{{ $t('pay.order_create_time') }}：{{ $formatTime(order.created_at) }}</span>
				<span class="mr-auto">{{ $t('pay.order_amount') }}：￥{{ order.totalamt }}</span>
				<span class="mr-auto">{{ $t('pay.pay_amount') }}：￥{{ order.payamt }}</span>
				<span class="mr-auto">总重量：{{ order.totalqty }}g</span>
				<span class="mr-auto">状态：{{ order.status }}</span>
				<template v-if="order.refundamount && order.refundamount > 0">
					<span class="mr-auto">{{ $t('pay.refund_amount') }}：￥{{ order.refundamount }}</span>
				</template>
				<span class="mr-auto" v-if="order.memo">{{ $t('pay.order_memo') }}：{{ order.memo }}</span>
			</div>
		</v-card-text>

		<v-table density="compact">
			<thead>
				<tr>
					<th class="text-left">名称</th>
					<th class="text-left">数量</th>
					<th class="text-left">金额</th>
				</tr>
			</thead>
			<tbody>
				<template v-for="(item, index) in order.items" :key="item.id">
					<tr>
						<td>{{ item.bean_name }}</td>
						<td>{{ item.qty }}g</td>
						<td>￥{{ item.amt }}</td>
					</tr>
				</template>
			</tbody>
		</v-table>
	</v-card>
</template>

<script>
export default {
	name: 'OrderCard',
	props: {
		order: { type: Object },
		showActions: { type: Boolean, default: true }
	},
	data() {
		return {
			showDetail: false,
			items: []
		}
	},
	mounted() {},
	methods: {
		pay() {
			this.$router.push({ path: '/pay/cashier/' + this.order.order_sn })
		},
		detail() {
			this.$router.push({ path: '/order/detail/' + this.order.order_sn })
		},
		show() {
			this.showDetail = !this.showDetail
			if (this.showDetail) {
				this.$http.get('/order/getItems/' + this.order.order_sn, {}).then((r) => {
					this.items = r
				})
			}
		},
		review() {
			this.$router.push(`/order/review/${this.order.order_sn}`)
		}
	}
}
</script>

<style scoped></style>
